import React from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

const ComicButton = props => {
    return (
        <Container className={props.className} onClick={props.onClick}>
            <TitleText>{props.title}</TitleText>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    min-width: 171px;
    height: 44px;
    overflow: hidden;
    border-radius: 6px;
    align-self: center;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #f55a86 0%, #ec098c 100%);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.35);
    border-radius: 6px;
    margin-top: 32px;
    color: transparent;
    padding: 0px 8px;
    cursor: pointer;
`;

const TitleText = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    color: white;
`;

export default ComicButton;
